import React from "react";
import ReactDOM from "react-dom";
import AppButton from "../../button/app-button";
import FormGeneric from "../form-generic";
import "./form-modal.css";

const FormModal = ({
	open,
	title,
	formId = "form-modal-form",
	formFields = [],
	errors = {},
	onClose,
	onSubmit,
	onFieldChange,
	submitLabel = "Salvar",
	cancelLabel = "Cancelar",
	submitDisabled = false
}) => {
	if (!open) {
		return null;
	}

	return ReactDOM.createPortal(
		<div className="form-modal__overlay">
			<div className="form-modal" role="dialog" aria-modal="true">
				<div className="form-modal__header">
					<h2 className="form-modal__title">
						{title}
					</h2>

					<button
						type="button"
						className="form-modal__close"
						onClick={onClose}
						aria-label="Fechar modal"
					>
						×
					</button>
				</div>

				<div className="form-modal__body">
					<FormGeneric
						formId={formId}
						formFields={formFields}
						message={null}
						errors={errors}
						onSubmit={onSubmit}
						onFieldChange={onFieldChange}
					/>
				</div>

				<div className="form-modal__footer">
					<AppButton
						type="button"
						onClick={onClose}
						className="form-modal__button form-modal__button--cancel"
					>
						{cancelLabel}
					</AppButton>

					<AppButton
						type="submit"
						form={formId}
						disabled={submitDisabled}
						className="form-modal__button form-modal__button--submit"
					>
						{submitLabel}
					</AppButton>
				</div>
			</div>
		</div>,
		document.body
	);
};

export default FormModal;